import { UserVo } from '@src/type'
import { actionType } from './actionType'

export interface initialStateProps {
  userInfo?: UserVo
  firstKey?: string
  secondKey?: number
}
export const initialState: initialStateProps = {
  firstKey: '1',
  secondKey: 1,
} as initialStateProps

export interface StoreAction {
  type: string
  payload?: any
}
export const reducers = (
  state = initialState,
  { type, payload }: StoreAction
) => {
  switch (type) {
    case actionType.SAVE_USER:
      return { ...state, userInfo: payload }
    case actionType.SAVE_FIRST_KEY:
      return { ...state, firstKey: payload }
    case actionType.SAVE_SECOND_KEY:
      return { ...state, secondKey: payload }

    default:
      return state
  }
}
